import { first } from 'lodash';

import asArray from 'utils/arrays/asArray.util';
import fromAnyToString from 'utils/converters/fromAnyToString';

const mergeOutstandingDepositsWithClients = (options) => {
  const deposits = asArray(options?.deposits);
  const clients = asArray(options?.clients);

  return deposits.map((deposit) => {
    const clientId = deposit?.clientId;

    const found = first(clients.filter((c) => c?.id === clientId));

    const clientName = fromAnyToString(found?.user_name) || fromAnyToString(found?.userName) || fromAnyToString(deposit.clientId);

    return { ...deposit, clientName };
  });
};

export default mergeOutstandingDepositsWithClients;
